var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents1" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "award-img" }, [
        _c("img", { attrs: { src: _vm.award01 } }),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.award02 } }),
        _vm._v(" "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.award03 } }),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.award04 } })
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "trophy-img" }, [
      _c("img", {
        staticClass: "trophy",
        attrs: { src: "static/img/trophy.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text1" }, [
      _vm._v("\n      출장정비 서비스 "),
      _c("span", [_vm._v("압도적 1위!")]),
      _c("br"),
      _vm._v("\n      누적 정비건수 "),
      _c("span", [_vm._v("430,000건 돌파!")]),
      _c("br"),
      _vm._v("\n      누적 이용후기 건수 "),
      _c("span", [_vm._v("100,000건!")]),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text2" }, [
      _vm._v("카수리가 "),
      _c("span", [_vm._v("유일")]),
      _vm._v("합니다.")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-345183d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345183d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents1.vue
// module id = null
// module chunks = 